import script from "./UserBaseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBaseInfo.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserBaseInfo.css?vue&type=style&index=0&id=353d5179&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=353d5179&scoped=true&lang=css&external"
import "./UserBaseInfo.vue?vue&type=style&index=2&id=353d5179&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353d5179"]])

export default __exports__